import React, { Component } from 'react';

import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import TextField from '@material-ui/core/TextField';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import CircularProgress from '@material-ui/core/CircularProgress';
import Tooltip from '@material-ui/core/Tooltip';
import Snackbar from '@material-ui/core/Snackbar';
import InputAdornment from '@material-ui/core/InputAdornment';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import Alert from '@material-ui/lab/Alert';
import Autocomplete from '@material-ui/lab/Autocomplete';

import SearchIcon from '@material-ui/icons/Search';
import RefreshIcon from '@material-ui/icons/Refresh';
import ViewListIcon from '@material-ui/icons/ViewList';
import RoomIcon from '@material-ui/icons/Room';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CancelIcon from '@material-ui/icons/Cancel';
import AssessmentIcon from '@material-ui/icons/Assessment';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import MapIcon from '@material-ui/icons/Map';
import BusinessIcon from '@material-ui/icons/Business';
import LocalOfferIcon from '@material-ui/icons/LocalOffer';
import DateRangeIcon from '@material-ui/icons/DateRange';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import FirstPageIcon from '@material-ui/icons/FirstPage';
import LastPageIcon from '@material-ui/icons/LastPage';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';

import { trackPromise } from 'react-promise-tracker';

import { HttpService } from '../service/HttpService';
import { AppBreadcrumb } from '../AppBreadcrumb';
import CheckPriviladge from '../hoc/CheckPriviladge';
import { checkForError } from '../utility/AppUtility';

// renamed to avoid clashing with the global `Map` object and the MUI `Map` icon
import { Map as LeafletMap, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

import markerIcon from "../images/marker-icon.png";
import markerIcon2x from "../images/marker-icon-2x.png";
import markerShadow from "../images/marker-shadow.png";

import './ProductQrList.css';


delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
    iconRetinaUrl: markerIcon2x,
    iconUrl: markerIcon,
    shadowUrl: markerShadow
});

// ---------------------------------------------------------------------------

const PERIOD_OPTIONS = [
    { label: "Last 30 Days", value: "30" },
    { label: "Last 60 Days", value: "60" },
    { label: "Last 90 Days", value: "90" },
    { label: "Lifetime", value: "1000000" }
];

export class ProductQrList extends Component {

    constructor(props) {
        super(props);

        this.httpService = new HttpService();

        this.state = {

            // Dashboard summary
            dashboard: {
                totalScan: 0,
                validScan: 0,
                invalidScan: 0
            },
            dashboardLoading: false,
            selectedPeriod: PERIOD_OPTIONS[0],

            // Dropdown data (id/label normalized so null or blank names never break the UI)
            customers: [],
            products: [],
            productsLoading: false,

            // Selected filters
            selectedCustomer: null,
            selectedProduct: null,
            code: "",
            fromDate: null,
            toDate: null,

            // View
            viewType: "list",

            // Table
            dataTableValue: [],

            // Pagination
            page: 0,
            size: 10,
            totalRecords: 0,

            loading: false,

            // Map
            activeMarker: null,

            address: null,

            addressLoading: false,

            addressError: false,

            // Snackbar (replaces Growl)
            snackbar: {
                open: false,
                severity: "info",
                message: ""
            }
        };
    }

    componentDidMount() {

        this.getDashboard(this.state.selectedPeriod);
        this.getCustomers();
        this.getProducts(null);
        this.getScanList();

    }

    fetchAddress = async (lat, lng) => {

        this.setState({
            addressLoading: true,
            addressError: false,
            address: null
        });

        try {

            const response = await fetch(
                `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}`
            );

            if (!response.ok) {
                throw new Error("Failed to fetch address");
            }

            const data = await response.json();

            this.setState({
                address: data,
                addressLoading: false
            });

        } catch (error) {

            console.error(error);

            this.setState({
                addressLoading: false,
                addressError: true
            });

        }

    };

    // -------------------------------------------------------------------
    // Data fetching
    // -------------------------------------------------------------------

    getDashboard = (period) => {

        const selectedPeriod =
            period || this.state.selectedPeriod;

        const days = selectedPeriod.value;

        this.setState({ dashboardLoading: true, selectedPeriod });

        const url =
            days === "1000000"
                ? "valid-scans/dashboard/scan-summary?days=100000"
                : `valid-scans/dashboard/scan-summary?days=${days}`;

        trackPromise(

            this.httpService
                .getApi(url)
                .then(response => {

                    this.setState({
                        dashboard: {
                            totalScan: response.data.totalScan || 0,
                            validScan: response.data.validScan || 0,
                            invalidScan: response.data.invalidScan || 0
                        },
                        dashboardLoading: false
                    });

                })
                .catch(error => {

                    this.setState({ dashboardLoading: false });

                    if (checkForError(error)) {
                        this.showMessage("error", "Error", error.response.data.title);
                    }

                })

        );

    }

    getCustomers = () => {

        trackPromise(

            this.httpService
                .getApi("customers/dropdown")
                .then(response => {

                    const customers = (response.data || []).map(c => ({
                        ...c,
                        label: this.cleanLabel(c.companyName) || c.id
                    }));

                    this.setState({ customers });

                })
                .catch(error => {

                    if (checkForError(error)) {
                        this.showMessage("error", "Error", error.response.data.title);
                    }

                })

        );

    }

    getProducts = (customerId) => {

        this.setState({ productsLoading: true });

        const url = customerId
            ? "products/dropdown/" + customerId
            : "products/dropdown/fetchAll";

        trackPromise(

            this.httpService
                .getApi(url)
                .then(response => {

                    const products = (response.data || []).map(p => ({
                        id: p.id,
                        label: this.cleanLabel(p.productCode) || p.id
                    }));

                    console.log("API Count:", response.data.length);
                    console.log("Dropdown Count:", products.length);


                    this.setState({
                        products,
                        productsLoading: false
                    });

                })
                .catch(error => {

                    this.setState({ productsLoading: false });

                    if (checkForError(error)) {
                        this.showMessage("error", "Error", error.response.data.title);
                    }

                })

        );

    }

    getScanList = (page = 0) => {

        this.setState({ loading: true });

        const params = new URLSearchParams();

        params.append("page", page);
        params.append("size", this.state.size);

        if (this.state.selectedCustomer) {
            params.append("customerId", this.state.selectedCustomer.id);
        }

        if (this.state.selectedProduct) {

            params.append(
                "productId",
                this.state.selectedProduct.id
            );

        }

        if (this.state.code && this.state.code.trim() !== "") {
            params.append("code", this.state.code.trim());
        }

        if (this.state.fromDate) {
            params.append("fromDate", this.formatDateForApi(this.state.fromDate));
        }

        if (this.state.toDate) {
            params.append("toDate", this.formatDateForApi(this.state.toDate));
        }

        const url = "valid-scans/api/product-valid-scans?" + params.toString();

        trackPromise(

            this.httpService
                .getApi(url)
                .then(response => {

                    this.setState({
                        dataTableValue: response.data.content || [],
                        totalRecords: response.data.totalElements || 0,
                        page: response.data.number || 0,
                        loading: false,
                        //activeMarker: null
                    });

                })
                .catch(error => {

                    this.setState({ loading: false });

                    if (checkForError(error)) {
                        this.showMessage("error", "Error", error.response.data.title);
                    }

                })

        );

    }

    // -------------------------------------------------------------------
    // Helpers
    // -------------------------------------------------------------------

    cleanLabel = (value) => {

        if (!value) return "";

        const cleaned = value.replace(/\s+/g, " ").trim();

        return cleaned;

    }

    formatDateForApi = (date) => {

        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");

        return `${year}-${month}-${day}`;

    }

    showMessage = (severity, summary, message) => {

        const normalizedSeverity =
            (severity === "error" || severity === "success" || severity === "warning")
                ? severity
                : "info";

        this.setState({
            snackbar: {
                open: true,
                severity: normalizedSeverity,
                message: `${summary}: ${message}`
            }
        });

    }

    closeSnackbar = () => {

        this.setState(prevState => ({
            snackbar: { ...prevState.snackbar, open: false }
        }));

    }

    // -------------------------------------------------------------------
    // Event handlers
    // -------------------------------------------------------------------

    onCustomerChange = (event, value) => {

        this.setState(
            {
                selectedCustomer: value,
                selectedProduct: null,
                products: []
            },
            () => {
                this.getProducts(value ? value.id : null);
            }
        );

    }

    onProductChange = (event, value) => {

        this.setState({
            selectedProduct: value
        });

    }

    onPeriodChange = (e) => {

        const period = PERIOD_OPTIONS.find(p => p.value === e.target.value);

        console.log("period change:", period);

        this.getDashboard(period);

    }

    onCodeChange = (e) => {

        this.setState({ code: e.target.value });

    }

    onFromDateChange = (e) => {

        const value = e.target.value;

        this.setState({ fromDate: value ? new Date(value + "T00:00:00") : null });

    }

    onToDateChange = (e) => {

        const value = e.target.value;

        this.setState({ toDate: value ? new Date(value + "T00:00:00") : null });

    }

    search = () => {

        this.getScanList(0);

    }

    resetSearch = () => {

        this.setState(
            {
                selectedCustomer: null,
                selectedProduct: null,
                products: [],
                code: "",
                fromDate: null,
                toDate: null,

                // Reset View - when reset button click revisit to list view 
                viewType: "list",
                activeMarker: null,
                address: null,
                addressLoading: false,
                addressError: false
            },
            () => {
                this.getProducts(null);
                this.getScanList(0);
            }
        );

    }

    onPageChange = (event, newPage) => {

        this.getScanList(newPage);

    }

    onRowsPerPageChange = (event) => {

        this.setState({ size: parseInt(event.target.value, 10) }, () => {
            this.getScanList(0);
        });

    }

    changeView = (view) => {

        if (view === "list") {
            this.setState({
                viewType: "list",
                activeMarker: null
            });
        }

    }

    viewLocation = (rowData) => {

        this.setState({

            activeMarker: rowData,

            viewType: "map"

        });

        this.fetchAddress(

            rowData.latitude,

            rowData.longitude

        );

    }

    // -------------------------------------------------------------------
    // Table cell renderers
    // -------------------------------------------------------------------

    formatDate = (date) => {

        if (!date) return "-";

        return new Date(date).toLocaleString();

    }

    // -------------------------------------------------------------------
    // Numbered pagination (Prev / 1 2 3 ... / Next)
    // -------------------------------------------------------------------

    buildPageList = (current, total) => {

        const delta = 1;
        const range = [];
        const rangeWithDots = [];
        let last;

        for (let i = 1; i <= total; i++) {

            if (i === 1 || i === total || (i >= current - delta && i <= current + delta)) {
                range.push(i);
            }

        }

        range.forEach((i) => {

            if (last) {

                if (i - last === 2) {
                    rangeWithDots.push(last + 1);
                } else if (i - last !== 1) {
                    rangeWithDots.push("...");
                }

            }

            rangeWithDots.push(i);

            last = i;

        });

        return rangeWithDots;

    }

    renderPagination = () => {

        const { page, size, totalRecords } = this.state;

        const totalPages = Math.max(1, Math.ceil(totalRecords / size));
        const currentPage = page + 1;
        const pages = this.buildPageList(currentPage, totalPages);

        const from = totalRecords === 0 ? 0 : page * size + 1;
        const to = Math.min(totalRecords, (page + 1) * size);

        return (

            <div className="pagination-bar">

                <div className="pagination-info">
                    Showing {from}-{to} of {totalRecords}
                </div>

                <div className="pagination-controls">

                    <IconButton
                        size="small"
                        className="page-btn"
                        disabled={page === 0}
                        onClick={() => this.getScanList(0)}
                    >
                        <FirstPageIcon fontSize="small" />
                    </IconButton>

                    <IconButton
                        size="small"
                        className="page-btn"
                        disabled={page === 0}
                        onClick={() => this.getScanList(page - 1)}
                    >
                        <ChevronLeftIcon fontSize="small" />
                    </IconButton>

                    {pages.map((p, idx) => (

                        p === "..." ? (
                            <span key={`dots-${idx}`} className="page-dots">
                                <MoreHorizIcon fontSize="small" />
                            </span>
                        ) : (
                            <Button
                                key={p}
                                className={p === currentPage ? "page-btn number active" : "page-btn number"}
                                onClick={() => this.getScanList(p - 1)}
                            >
                                {p}
                            </Button>
                        )

                    ))}

                    <IconButton
                        size="small"
                        className="page-btn"
                        disabled={page >= totalPages - 1}
                        onClick={() => this.getScanList(page + 1)}
                    >
                        <ChevronRightIcon fontSize="small" />
                    </IconButton>

                    <IconButton
                        size="small"
                        className="page-btn"
                        disabled={page >= totalPages - 1}
                        onClick={() => this.getScanList(totalPages - 1)}
                    >
                        <LastPageIcon fontSize="small" />
                    </IconButton>

                </div>

                <FormControl size="small" variant="outlined" className="rows-per-page">
                    <Select value={size} onChange={this.onRowsPerPageChange}>
                        <MenuItem value={10}>10 / page</MenuItem>
                        <MenuItem value={25}>25 / page</MenuItem>
                        <MenuItem value={50}>50 / page</MenuItem>
                    </Select>
                </FormControl>

            </div>

        );

    }

    renderMap = () => {

        const {

            activeMarker,

            address,

            addressLoading,

            addressError

        } = this.state;

        if (!activeMarker) {

            return (

                <div className="map-state">

                    <MapIcon style={{ fontSize: 40, color: "#b0b7bf" }} />

                    <p>No Location Selected</p>

                </div>

            );

        }

        const addr = address ? address.address : {};

        return (

            <div className="map-flex-container">

                {/* MAP */}

                <div className="map-pane">

                    <LeafletMap
                        center={[
                            activeMarker.latitude,
                            activeMarker.longitude
                        ]}
                        zoom={15}
                        style={{
                            height: "100%",
                            width: "100%"
                        }}
                    >

                        <TileLayer
                            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                        />

                        <Marker
                            position={[
                                activeMarker.latitude,
                                activeMarker.longitude
                            ]}
                        >

                            <Popup>

                                {activeMarker.code}

                            </Popup>

                        </Marker>

                    </LeafletMap>

                </div>

                {/* ADDRESS */}

                <div className="address-pane">

                    <h3>

                        Address Details

                    </h3>

                    {
                        addressLoading &&

                        <Box display="flex" alignItems="center" style={{ gap: 8 }}>
                            <CircularProgress size={18} />
                            <p style={{ margin: 0, boxShadow: "none", background: "transparent", border: "none", padding: 0 }}>
                                Loading address...
                            </p>
                        </Box>
                    }

                    {
                        addressError &&

                        <div>

                            <p>

                                Unable to fetch address.

                            </p>

                            <p>

                                Please try again after some time.

                            </p>

                        </div>

                    }

                    {
                        address &&

                        <>

                            <p>

                                <b>Road :</b>

                                {addr.road || "-"}

                            </p>

                            <p>

                                <b>City :</b>

                                {addr.city || addr.town || addr.village || "-"}

                            </p>

                            <p>

                                <b>District :</b>

                                {addr.county || "-"}

                            </p>

                            <p>

                                <b>State :</b>

                                {addr.state || "-"}

                            </p>

                            <p>

                                <b>Country :</b>

                                {addr.country || "-"}

                            </p>

                            <p>

                                <b>Pincode :</b>

                                {addr.postcode || "-"}

                            </p>

                            <hr />

                            <p>

                                <b>Latitude :</b>

                                {activeMarker.latitude}

                            </p>

                            <p>

                                <b>Longitude :</b>

                                {activeMarker.longitude}

                            </p>

                            <Button
                                variant="contained"
                                color="primary"
                                fullWidth
                                startIcon={<OpenInNewIcon />}
                                onClick={() =>
                                    window.open(
                                        `https://www.google.com/maps?q=${activeMarker.latitude},${activeMarker.longitude}`,
                                        "_blank"
                                    )
                                }
                                style={{ marginBottom: 10 }}
                            >
                                Open Google Maps
                            </Button>

                            <Button
                                variant="outlined"
                                fullWidth
                                startIcon={<MapIcon />}
                                onClick={() =>
                                    window.open(
                                        `https://www.openstreetmap.org/?mlat=${activeMarker.latitude}&mlon=${activeMarker.longitude}#map=16/${activeMarker.latitude}/${activeMarker.longitude}`,
                                        "_blank"
                                    )
                                }
                            >
                                Open OpenStreetMap
                            </Button>

                        </>

                    }

                </div>

            </div>

        );

    }
    // -------------------------------------------------------------------
    // Render
    // -------------------------------------------------------------------

    render() {

        const {
            dashboard,
            viewType,
            dataTableValue,
            loading,
            size,
            page,
            totalRecords,
            customers,
            products,
            productsLoading,
            selectedCustomer,
            selectedProduct,
            code,
            fromDate,
            toDate,
            snackbar
        } = this.state;

        return (
            <>

                <AppBreadcrumb breadcrumdItems={[{ label: 'QR Scan Dashboard' }]} />

                <Grid container>

                    <Grid item xs={12}>

                        {/* Dashboard Cards */}

                        <Grid container spacing={2} alignItems="flex-end">

                            <Grid item xs={6} md={2}>
                                <Paper className="dashboard-card" elevation={0}>
                                    <div className="dashboard-card-header">
                                        <span className="dashboard-title">Total Scans</span>
                                        <AssessmentIcon className="dashboard-icon" />
                                    </div>
                                    <div className="dashboard-count">{dashboard.totalScan.toLocaleString()}</div>
                                </Paper>
                            </Grid>

                            <Grid item xs={6} md={2}>
                                <Paper className="dashboard-card" elevation={0}>
                                    <div className="dashboard-card-header">
                                        <span className="dashboard-title">Valid Scans</span>
                                        <CheckCircleIcon className="dashboard-icon valid" />
                                    </div>
                                    <div className="dashboard-count valid">{dashboard.validScan.toLocaleString()}</div>
                                </Paper>
                            </Grid>

                            <Grid item xs={6} md={2}>
                                <Paper className="dashboard-card" elevation={0}>
                                    <div className="dashboard-card-header">
                                        <span className="dashboard-title">Invalid Scans</span>
                                        <CancelIcon className="dashboard-icon invalid" />
                                    </div>
                                    <div className="dashboard-count invalid">{dashboard.invalidScan.toLocaleString()}</div>
                                </Paper>
                            </Grid>

                            <Grid item xs={12} md={3} className="period-select-col">

                                <FormControl fullWidth variant="outlined" size="small" disabled={this.state.dashboardLoading}>
                                    <InputLabel>Period</InputLabel>
                                    <Select
                                        value={this.state.selectedPeriod.value}
                                        onChange={this.onPeriodChange}
                                        input={
                                            <OutlinedInput
                                                label="Period"
                                                startAdornment={
                                                    <InputAdornment position="start">
                                                        <DateRangeIcon fontSize="small" style={{ color: "#94a3b8" }} />
                                                    </InputAdornment>
                                                }
                                            />
                                        }
                                    >
                                        {PERIOD_OPTIONS.map(opt => (
                                            <MenuItem key={opt.value} value={opt.value}>{opt.label}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>

                            </Grid>

                            <Grid item xs={12} md={3} className="view-toggle-col">

                                <div className="view-toggle-group">

                                    <Button
                                        startIcon={<ViewListIcon />}
                                        className={viewType === "list" ? "toggle-btn active" : "toggle-btn"}
                                        disabled={viewType === "list"}
                                        onClick={() => this.changeView("list")}
                                    >
                                        List
                                    </Button>

                                    <Button
                                        startIcon={<RoomIcon />}
                                        className={viewType === "map" ? "toggle-btn active" : "toggle-btn"}
                                        disabled={viewType === "map" || this.state.activeMarker == null}
                                    >
                                        Map
                                    </Button>

                                </div>

                            </Grid>

                        </Grid>

                        {/* Filters */}

                        <Paper className="filter-bar" elevation={0}>

                            <Grid container spacing={2} alignItems="flex-end">

                                <Grid item xs={12} md={3}>
                                    <Autocomplete
                                        size="small"
                                        options={customers}
                                        getOptionLabel={(option) => option.label || ""}
                                        value={selectedCustomer}
                                        onChange={this.onCustomerChange}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Customer"
                                                variant="outlined"
                                                placeholder="Select Customer"
                                                InputProps={{
                                                    ...params.InputProps,
                                                    startAdornment: (
                                                        <InputAdornment position="start">
                                                            <BusinessIcon fontSize="small" style={{ color: "#94a3b8" }} />
                                                        </InputAdornment>
                                                    )
                                                }}
                                            />
                                        )}
                                    />
                                </Grid>

                                <Grid item xs={12} md={3}>
                                    <Autocomplete
                                        size="small"
                                        options={products}
                                        loading={productsLoading}
                                        getOptionLabel={(option) => option.label || ""}
                                        value={selectedProduct}
                                        onChange={this.onProductChange}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Product"
                                                variant="outlined"
                                                placeholder="Select Product"
                                                InputProps={{
                                                    ...params.InputProps,
                                                    startAdornment: (
                                                        <InputAdornment position="start">
                                                            <LocalOfferIcon fontSize="small" style={{ color: "#94a3b8" }} />
                                                        </InputAdornment>
                                                    ),
                                                    endAdornment: (
                                                        <>
                                                            {productsLoading ? <CircularProgress color="inherit" size={16} /> : null}
                                                            {params.InputProps.endAdornment}
                                                        </>
                                                    )
                                                }}
                                            />
                                        )}
                                    />
                                </Grid>

                                <Grid item xs={12} md={2}>
                                    <TextField
                                        label="Code"
                                        size="small"
                                        variant="outlined"
                                        fullWidth
                                        value={code}
                                        onChange={this.onCodeChange}
                                        placeholder="Enter QR Code"
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <SearchIcon fontSize="small" style={{ color: "#94a3b8" }} />
                                                </InputAdornment>
                                            )
                                        }}
                                    />
                                </Grid>

                                <Grid item xs={6} md={2}>
                                    <TextField
                                        label="From Date"
                                        type="date"
                                        size="small"
                                        variant="outlined"
                                        fullWidth
                                        InputLabelProps={{ shrink: true }}
                                        value={fromDate ? this.formatDateForApi(fromDate) : ""}
                                        onChange={this.onFromDateChange}
                                        inputProps={{ max: toDate ? this.formatDateForApi(toDate) : undefined }}
                                    />
                                </Grid>

                                <Grid item xs={6} md={2}>
                                    <TextField
                                        label="To Date"
                                        type="date"
                                        size="small"
                                        variant="outlined"
                                        fullWidth
                                        InputLabelProps={{ shrink: true }}
                                        value={toDate ? this.formatDateForApi(toDate) : ""}
                                        onChange={this.onToDateChange}
                                        inputProps={{ min: fromDate ? this.formatDateForApi(fromDate) : undefined }}
                                    />
                                </Grid>

                            </Grid>

                            <div className="filter-actions">

                                <Button
                                    variant="contained"
                                    color="primary"
                                    startIcon={<SearchIcon />}
                                    onClick={this.search}
                                >
                                    Search
                                </Button>

                                <Button
                                    variant="outlined"
                                    startIcon={<RefreshIcon />}
                                    onClick={this.resetSearch}
                                >
                                    Reset
                                </Button>

                            </div>

                        </Paper>

                        {/* LIST VIEW */}

                        {viewType === "list" ? (

                            <Paper className="table-wrapper" elevation={0}>

                                <TableContainer>

                                    <Table size="small">

                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Code</TableCell>
                                                <TableCell>Customer</TableCell>
                                                <TableCell>Product</TableCell>
                                                <TableCell>Scan Time</TableCell>
                                                <TableCell>Latitude</TableCell>
                                                <TableCell>Longitude</TableCell>
                                                <TableCell align="center" style={{ width: 120 }}>View Location</TableCell>
                                            </TableRow>
                                        </TableHead>

                                        <TableBody>

                                            {loading && (
                                                <TableRow>
                                                    <TableCell colSpan={7} align="center" style={{ padding: 32 }}>
                                                        <CircularProgress size={28} />
                                                    </TableCell>
                                                </TableRow>
                                            )}

                                            {!loading && dataTableValue.length === 0 && (
                                                <TableRow>
                                                    <TableCell colSpan={7} align="center" style={{ padding: 32, color: "#94a3b8" }}>
                                                        No scans found for the selected filters.
                                                    </TableCell>
                                                </TableRow>
                                            )}

                                            {!loading && dataTableValue.map((row) => {

                                                const locationDisabled =
                                                    row.latitude == null || row.longitude == null || row.latitude === 0 || row.longitude === 0;

                                                const tooltipText = locationDisabled
                                                    ? "Location not available"
                                                    : "View Location";

                                                return (
                                                    <TableRow key={row.id} hover>
                                                        <TableCell>
                                                            <span className="scan-code">{row.code}</span>
                                                        </TableCell>
                                                        <TableCell>{this.cleanLabel(row.customerName) || "-"}</TableCell>
                                                        <TableCell>{this.cleanLabel(row.productName) || "-"}</TableCell>
                                                        <TableCell>{this.formatDate(row.createdDate)}</TableCell>
                                                        <TableCell>
                                                            {(row.latitude === null || row.latitude === undefined) ? "-" : row.latitude.toFixed(5)}
                                                        </TableCell>
                                                        <TableCell>
                                                            {(row.longitude === null || row.longitude === undefined) ? "-" : row.longitude.toFixed(5)}
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            <Tooltip
                                                                title={tooltipText}
                                                                placement="top"
                                                                arrow
                                                            >
                                                                <span>
                                                                    {/* <IconButton
                                                                        size="small"
                                                                        color="primary"
                                                                        disabled={locationDisabled}
                                                                        onClick={() => this.viewLocation(row)}
                                                                    >
                                                                        <RoomIcon fontSize="small" />
                                                                    </IconButton> */}
                                                                    <IconButton
                                                                        color="primary"
                                                                        style={{ padding: 10 }}
                                                                        disabled={locationDisabled}
                                                                        onClick={() => this.viewLocation(row)}
                                                                    >
                                                                        <RoomIcon style={{ fontSize: 30 }} />
                                                                    </IconButton>
                                                                </span>
                                                            </Tooltip>
                                                        </TableCell>
                                                    </TableRow>
                                                );

                                            })}

                                        </TableBody>

                                    </Table>

                                </TableContainer>

                                {this.renderPagination()}

                            </Paper>

                        ) : (

                            this.renderMap()

                        )}

                    </Grid>

                </Grid>

                <Snackbar
                    open={snackbar.open}
                    autoHideDuration={5000}
                    onClose={this.closeSnackbar}
                    anchorOrigin={{ vertical: "top", horizontal: "right" }}
                >
                    <Alert onClose={this.closeSnackbar} severity={snackbar.severity} elevation={6} variant="filled">
                        {snackbar.message}
                    </Alert>
                </Snackbar>

            </>
        );

    }
}
